




import Vue from 'vue'
import { insertCommaDelimiter } from '@/utils/helpers';

export default Vue.extend({
  name: 'Badge',
  props: {
    num: {
      type: [Number, String],
      default: ''
    },
    top: {
      type: String,
      default: ''
    },
    left: {
      type: String,
      default: ''
    },
    right: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'absolute'
    },
    size: {
      default: 26,
      type: Number
    },
    type: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 1
    }
  },
  computed: {
    style(): string {
      let style = `width: ${this.size}px; height: ${this.size}px;`
      if (this.top) {
        style += `top: ${this.top};`
      }
      if (this.right) {
        style += `right: ${this.right};`
      }
      if (this.left) {
        style += `left: ${this.left};`
      }
      return style
    }
  }
})
